import { Fragment } from 'react';
import { Text } from '@repletoryreach/sdk-ui';

/** Paragraphs split by blank lines; a run of lines starting with "- " becomes a bullet list. */
export function GuideText({ text, size = 'bodySmall' }: { text: string; size?: 'bodySmall' | 'body' }) {
  const blocks = text.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <>
      {blocks.map((block, i) => {
        const lines = block.split('\n').map((l) => l.trim());
        if (lines.every((l) => l.startsWith('- '))) {
          return (
            <ul key={i} className="rr-guide__list">
              {lines.map((l, j) => <li key={j}><Text role={size} inline>{l.slice(2)}</Text></li>)}
            </ul>
          );
        }
        return (
          <Text key={i} role={size}>
            {lines.map((l, j) => <Fragment key={j}>{j > 0 && <br />}{l}</Fragment>)}
          </Text>
        );
      })}
    </>
  );
}
